import { useQuery } from '@apollo/client';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { MY_PETS_QUERY } from './portal.gql';

/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */

export function PortalPetsPage(): JSX.Element {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(MY_PETS_QUERY, { fetchPolicy: 'cache-and-network' });
  const pets: any[] = data?.myPets ?? [];

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold">{t('portal.nav_pets')}</h2>
      {loading && pets.length === 0 ? (
        <p className="text-muted-foreground text-sm">{t('common.loading')}</p>
      ) : error && pets.length === 0 ? (
        <p className="text-destructive text-sm">{t('portal.load_error')}</p>
      ) : pets.length === 0 ? (
        <p className="text-muted-foreground text-sm">{t('portal.no_pets')}</p>
      ) : (
        <ul className="space-y-2">
          {pets.map((p) => (
            <li key={p.id}>
              <Link
                to={`/portal/pets/${p.id}`}
                className="bg-background flex items-center justify-between gap-2 rounded-xl border p-3"
              >
                <div className="min-w-0">
                  <p className="font-medium">{p.name}</p>
                  <p className="text-muted-foreground truncate text-xs">
                    {[p.species, p.breed].filter(Boolean).join(' · ') || '—'}
                  </p>
                </div>
                <ChevronRight className="text-muted-foreground h-5 w-5" aria-hidden />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
